export const version = '0.104.0 (build: 589)'
export const versions = [
  {
    version: '0.104.0',
    items: [
      'odstranění sloupců LOWE index, Zákaznické hodnocení, Teplota ve stroji ze zjednodušeného seznamu lahví',
      'změna přednastaveného objemu lahve u nového vína z 0,5 na 0,75l',
      'u vinaře odstraněno povinné vyplnění Stylu vinohradnictví a Stylu výroby vína',
      'přidání tlačítek Prodat v baru/v e-shopu-v obchodě/jinak',
      'dashboard Prodejní kanály - zobrazení dat jen z aktuálního roku',
      'dashboard Objednané lahve - zohlednění příznaku smazané objednávky'
    ]
  },
  {
    version: '0.103.0',
    items: [
      'testovací verze zjednodušeného seznamu lahví pro roli WineEditor'
    ]
  },
  {
    version: '0.102.0',
    items: [
      'výměna sloupce Region za Dodavatelé ve vínech na skladě',
      'přidáno tlačítko Prodat ve stroji'
    ]
  },
  {
    version: '0.101.1',
    items: [
      'úprava velikosti sloupců v gridu se seznamem vín'
    ]
  },
  {
    version: '0.101.0',
    items: [
      'ošetření zpracování NULL hodnoty při výběru numerického typu filtru',
      'přidání jména skladů do gridu se seznamem vín'
    ]
  },
  {
    version: '0.100.0',
    items: [
      'zohlednění smazaných lahví v pohledu na vína na skladě',
      'zobrazování editace lahve v dialogu i pro 1 láhev, pokud je aktivní multiselect',
      'zohlednění aktualizace již existujících lahví u automatického přepnutí stavu na Dodáno při naskladňování',
    ]
  },
  {
    version: '0.99.0',
    items: [
      'update .NET na verzi 7.0',
      'update ABP frameworku na verzi 8.2.0',
      'update ostatních komponent na nejnovější verze',
      'checkbox pro automatický přechod zpět na seznam vín po uložení změn',
      'zvýšení rozsahu validace pro umístění ve skladu',
      'zrušení povinnosti zadat ročník u vína',
      'přidání objemu lahve 0,5l na obrazovce pro zadání vína',
      'dashboard - největší dodavatelé, zvětšení počtu dodavatelů',
      'dashboard - prodeje - přidání položky "V tomto roce"',
      'automatické nastavení kurzu 1.00 při výběru CZK měny',
      'automatické nastavení stavu na Dodáno při naskladnění lahví',
      'objednávky - předvybraný způsob platby bankovním převodem',
      'nová stránka - seznam vín na skladě + dialog s detailem počtu lahví na skladech',
    ]
  },
  {
    version: '0.95.0',
    items: [
      'implementace filtru pro export do Excelu',
      'zašednutí tlačítka naskladnění pro objednávky ve stavu Nová',
      'zohlednění smazaných entit (lahví/objednávek/...) v dashboardu',
      'zohlednění smazných objednávek v detailu lahve (info o počtu lahví daného vína)'
    ]
  },
  {
    version: '0.94.0',
    items: [
      'oprava pádu dashboardu v případě chybějících lahví'
    ]
  },
  {
    version: '0.93.0',
    items: [
      'WSET hodnoceni',
      'umístění ve skladu'
    ]
  },
  {
    version: '0.92.0',
    items: [
      'změna povinnosti zadávání polí',
      'číselník hodnotitelů'
    ]
  },
  {
    version: '0.91.0',
    items: [
      'číselníky pro typ vína, klasifikaci dle původu a klasifikaci dle parametrů',
      'víno - přidány číselníky + pole alkohol, kyselina a cukr',
      'dashboard - přidání řádku CELKEM do stavu skladů',
    ]
  },
  {
    version: '0.90.1',
    items: [
      'víno - přejmenovávání položek, změna LOWE indexu na výčtový typ',
      'dashboard - přidání řádku CELKEM do objednaných lahví',
      'vinaři - uložit jako dodavatel, zvětšení komentáře'
    ]
  },
  {
    version: '0.90.0',
    items: [
      'release notes - odstranění tlačítka i serverové části pro smazání všech lahví',
      'menu - změna pořadí položek v levém menu'
    ]
  },
  {
    version: '0.13.0',
    items: [
      'dodavatel - doplnění polí Stát, DIČ, Bankovní účet, Telefonní číslo a komentář',
      'sklad - doplnění polí kapacita skladu (v litreach a počtu lahví), teplota a komentář',
      'regiony - doplnění polí země, oblast, podoblast a komentář',
      'seznam vín - upraven stránkovač - přidáno 50 a 100 položek na stránku',
      'víno - expirace -> 2200 max, bez DPH, volitelné odrůdy vína, oblast změněn na region, přidán objem lahve a komentář',
      'přidáno oranžový druh vína',
      'seznamy měn, kurz do objednavky vína',
      'přepočet ceny vína pokud je zadána měna a kurz',
      'přidán styl vinohradnictví a styl výroby',
      'přidán datum a způsob zaplacení objednávky',
      'footer logo, WineList s.r.o.',
      'bugfix - tooltip validace namísto hodnoty zobrazoval jméno validované hodnoty',
    ]
  },
  {
    version: '0.12.0',
    items: [
      'rozběhnutí winelistu na novém serveru'
    ]
  },
  {
    version: '0.11.0',
    items: [
      'pokus o zprovoznění objemnějšího exportu na serveru, přidáno detailnější logování procesu'
    ]
  },
  {
    version: '0.10.0',
    items: [
      'dočasné zablokování exportu do excelu'
    ]
  },
  {
    version: '0.9.0',
    items: [
      'zrusšení koše na všech číselnících'
    ]
  },
  {
    version: '0.8.0',
    items: [
      'přidána indikace vysypavaní koše',
      'přidána indikace vytváření lahví při odeslání objednávky',
      'zrychlení mazaní všech lahví'
    ]
  },
  {
    version: '0.7.1',
    items: [
      'do release notes přidána možnost smazání všech lahví (určeno jen k testování)'
    ]
  },
  {
    version: '0.7.0',
    items: [
      'dashboard položka Objednané lahve',
      'rozšíření stránkovače seznamu lahví',
      'zavedení vypínatelného multi-selectu',
      'výměna animovaných checkboxů za defaultní z důvodu výkonnostních problémů při zobrazení 100 záznamů na stránce',
      'ukládání poslední vybrané skupiny filtrů'
    ]
  },
  {
    version: '0.6.0',
    items: [
      'přidána možnost editace vína z detailu lahve',
      'přidán výběr vína a datum objednání do formuláře detailu lahve',
      'možnost vytváření lahví tlačítkem přidat',
      'bugfix - zrušení aplikování filtrů v koši lahví',
      'úprava naskladňování - již vytvořené lahve jen upravuje namísto vytváření nových'
    ]
  },
  {
    version: '0.5.1',
    items: [
      'vylepšení validací na detailu lahve',
      'automatické nastavení stavu naskladňované lahve',
      'vytváření lahví při odeslání objednávky'
    ]
  },
  {
    version: '0.5.0',
    items: [
      'další změna databázové struktury',
      'změna formuláře pro editaci lahve',
      'naskladňování nyní pracuje jen s odeslanými objednávkami',
      'odesílání objednávek'
    ]
  },
  {
    version: '0.4.0',
    items: [
      'změna databázové struktury',
      'rozšíření formuláře pro editaci vína',
      'přidána možnost uložit víno jako nový záznam',
      'přidáno vysypání koše'
    ]
  },
  {
    version: '0.3.1',
    items: [
      'dashboard položka Stav skladů',
      'dashboard položka Počet prodaných lahví dle prodejního kanálu',
      'dashboard položka Prodeje za různá období',
    ]
  },
  {
    version: '0.3.0',
    items: [
      'přidán upload obrázků vína',
      'zobrazení obrázku vína i u příslušné lahve',
      'přidán dashboard Největší dodavatelé'
    ]
  },
  {
    version: '0.2.3',
    items: [
      'oprava konfigurace ukládání souborů na serveru'
    ]
  },
  {
    version: '0.2.2',
    items: [
      'prodloužení timeoutu pro naskladňování lahví na 2 minuty',
      'znemožnění spuštění naskladňování dokud není předchozí ukončeno (nebo vypršel limit)',
      'zobrazení chybové hlášky v případě selhání stažení souboru',
      'ošetření generování excel exportu v případě prázdné tabulky s lahvemi',
      'přidání refresh tlačítka do boxu soubory ke stažení'
    ]
  },
  {
    version: '0.2.1',
    items: [
      'přidány chybějící sloupce do excel exportu',
      'pokus o opravu problému s nefunkčním automatickým refreshem na serveru'
    ]
  },
  {
    version: '0.2.0',
    items: [
      'implementace systému běhu na pozadí',
      'implementace stahování souborů',
      'základní generování Excel exportu lahví (zatím bez fitrů)',
    ]
  },
  {
    version: '0.1.3',
    items: [
      'hromadná editace lahví'
    ]
  },
  {
    version: '0.1.2',
    items: [
      'dokončení skupin filtrů'
    ]
  },
  {
    version: '0.1.1',
    items: [
      'základ pro skupiny filtrů - chybí mazání, padá při výběru filtru s násobným výběrem'
    ]
  },
  {
    version: '0.1.0',
    items: [
      'přidání dalších typů filtru lahví',
      'úprava zobrazených sloupců v seznamu lahví',
      'změna datového typu expirace z data na číselnou hodnotu',
      'přidáno tlačítko na vymazání všech filtrů'
    ]
  },
  {
    version: '0.0.9',
    items: [
      'základní implementace filtru lahví'
    ]
  },
  {
    version: '0.0.8',
    items: [
      'vytváření lahví na základě objednávky',
      'seznam lahví',
      'detail lahve'
    ]
  },
  {
    version: '0.0.7',
    items: [
      'přesun objednávek do pod-menu',
      'základ pro zpracování objednávky'
    ]
  },
  {
    version: '0.0.6',
    items: [
      'automatické vybrání nově vytvořené položky v drop down listu',
      'oprava serverově načítáného dropdownlistu',
      'přidána persistence filtrů v gridech',
      'přesun dodavatelů a seznam vín pod číselníky',
      'přesun ceny za láhev z vína na objednané víno'
    ]
  },
  {
    version: '0.0.5',
    items: [
      'opravy drobných chyb',
      'přidáno tlačítko pro rychlé vytvoření dodavatele na formulář objednávky',
      'přesun administrace vín z dialogu do stránky',
      'předělání bočního menu'
    ]
  },
  {
    version: '0.0.4',
    items: [
      'UI pro objednávku vín',
      'UI pro administraci objednaných vín',
      'oprava dropdownlistů se serverovým načítáním'
    ]
  },
  {
    version: '0.0.3',
    items: [
      'číselník pro odrůdy vína, producenta, styl vína, typ skladování',
      'administrace číselníků',
      'základ pro objednávky',
      'výměna loga',
      'odstranění odrůdy vína z entity dodavatele'
    ]
  },
  {
    version: '0.0.2',
    items: [
      'poznámky k verzím'
    ]
  },
  {
    version: '0.0.1',
    items: [
      'základní kostra aplikace - nástřel editace dodavatele',
      'úpravy pro automatický build a nasazení'
    ]
  }
]